import { Divider } from '@cobliteam/ui/components';
import { FormField, FormItem, FormMessage, useFieldArray, useFormContext } from '@cobliteam/ui/form';
import { DraggableList } from '@cobliteam/ui-business/components';
import type { FormValues } from '../checklistSchema';
import ChecklistItem from './ChecklistItem';
import ChecklistItemDropdown from './ChecklistItemDropdown';

const ChecklistItems = () => {
  const { control } = useFormContext<FormValues>();
  const {
    fields: items,
    append: addItem,
    remove: removeItem,
    swap: swapItems,
  } = useFieldArray({
    control,
    name: 'items',
  });

  const handleReorder = (newOrder: typeof items) => {
    let swappedIndexes: [number, number] | null = null;
    newOrder.forEach((item, index) => {
      if (item.id !== items[index].id) {
        swappedIndexes = [index, items.findIndex((f) => f.id === item.id)];
      }
    });

    if (!swappedIndexes) return;
    swapItems(swappedIndexes[0], swappedIndexes[1]);
  };

  return (
    <FormField control={control} name='items'>
      {() => (
        <FormItem className='flex flex-col items-start gap-5'>
          {items.length > 0 && (
            <DraggableList values={items} onReorder={handleReorder} className='flex w-full flex-col gap-5'>
              {items.map((item, index) => (
                <DraggableList.Item key={item.id} value={item} renderItem={(dragControls) => <ChecklistItem index={index} removeItem={removeItem} dragControls={dragControls} />} />
              ))}
            </DraggableList>
          )}

          {items.length > 0 && <Divider />}

          <ChecklistItemDropdown addItem={addItem} />
          {items.length === 0 && <FormMessage />}
        </FormItem>
      )}
    </FormField>
  );
};

export default ChecklistItems;
